export class UvxTableModel {

    columns: UvxTableColumnModel[];
    data: any[];
}

class UvxTableColumnModel {
    header: string;
    field: any;
    sortable: boolean;
    sortFunction: any;
    filterable: boolean;
    filter?:string;
}